<div [ngStyle]="{ 'display' : performanceService.active? 'block' : 'none'}" [ngClass]="tabsService.minimizeScreenMode ? 'bottom-menu minimized' : ''">
  <form autocomplete="off"  id="ngPerformanceService" [ngClass]="[this.performanceService.active ? 'active' : '',  tabsService.fullScreenMode ? 'fullscreen' : '']" name="ngPerformanceComponent">
    <div class="fields__block">
      <div class="fields__block__section">
        <div class="title">
          <h4>NavAid Information</h4>
          <span></span>
        </div>
        <div class="table-fields">
          <div style="height: 240px; overflow-y: auto;">
              <table>
                <caption>
                </caption>
                <thead>
                  <tr>
                    <th scope="col">NavAidId</th>
                    <th scope="col">Name</th>
                    <th scope="col">NavAid Type</th>
                    <th scope="col" style="width: 100px">Latitude</th>
                    <th scope="col" style="width: 100px">Longitude</th>
                    <th scope="col">Altitude [ft]</th>
                    <th scope="col">DOC [NM]</th>
                    <th scope="col">Sectorized</th>
                    <th scope="col">VHF Frequency</th>
                    <th scope="col">Channel</th>
                    <th scope="col">Notes</th>
                  </tr>
                </thead>
                <tbody>
                  <tr mdbTableCol *ngFor="let navaid of this.getNavaids(); let i = index"
                  >
                    <td>{{navaid.navaidId }}</td>
                    <td>{{ navaid.name }}</td>
                    <td>{{ navaid.navaidType }}</td>
                    <td style="width: 100px">{{navaid.latitude}}</td>
                    <td style="width: 100px">{{ navaid.longitude }}</td>
                    <td>{{ navaid.altitude}}</td>
                    <td>{{ navaid.doc }}</td>
                    <td>{{ navaid.sectorized }}</td>
                    <td>{{ navaid.vhfTunFreqInput }}</td>
                    <td>{{ navaid.channel }} </td>
                    <td>
                      <input type="text" (change)="this.performanceService.report.navaidsTable[i].notes = ($event.target.value)">
                    </td>

                  </tr>
                </tbody>
              </table>
          </div>
        </div>
      </div>
      <div class="fields__block__section">
        <div class="title">
          <h4>Procedure Information</h4>
          <span></span>
        </div>
        <div class="table-fields">
          <div style="height: 240px; overflow-y: auto;">
            <table>
              <caption>
              </caption>
              <thead>
                <tr>
                  <th scope="col">WP Number / Begin / End</th>
                  <th scope="col">ID</th>
                  <th scope="col">Name</th>
                  <th scope="col">WP Type</th>
                  <th scope="col">Latitude</th>
                  <th scope="col">Longitude</th>
                  <th scope="col">Altitude [ft]</th>
                  <th scope="col">Notes</th>
                </tr>
              </thead>
              <tbody>
                <tr mdbTableCol *ngFor="let point of this.getProcedureTable(); let i = index;"
                >
                  <td>{{point.wpNumber}}</td>
                  <td>{{point.id}}</td>
                  <td>{{point.name}}</td>
                  <td>{{point.wpType}}</td>
                  <td>{{point.latitude}}</td>
                  <td>{{point.longitude}}</td>
                  <td>{{point.altitude}}</td>
                  <td>
                    <input type="text" (change)="this.performanceService.report.procedureTable[i].notes = ($event.target.value)">
                  </td>

              </tbody>
            </table>
        </div>
        </div>
      </div>
      <div class="fields__block__section">
        <div class="title">
          <h4> Performance Table Analysis</h4>
          <span></span>
        </div>
        <div class="table-fields">
          <div style="height: 240px; overflow-y: auto;">
          <table>
            <caption>
            </caption>
            <thead>
              <tr>
                <th scope="col"> Segment ID</th>
                <th scope="col"> Navaid Pair</th>
                <th scope="col"> Coverage Status</th>
                <th scope="col"> Subtended Angle (Start-End)</th>
                <th scope="col"> Subtended Angle (Min-Max)</th>
                <th scope="col">Notes</th>
              </tr>
            </thead>
            <tbody>
              <tr mdbTableCol *ngFor="let segment of this.getPerformanceTable();let i = index">
                <td>{{segment.segmentID}}</td>
                <td>{{segment.segmentID == null ? segment.navaid1ID + " - " + segment.navaid2ID: ""}}</td>
                <td>{{segment.totalCoverage}}</td>
                <td>{{segment.segmentID == null ? segment.startSubtendedAngle + " - " + segment.endSubtendedAngle: ""}}</td>
                <td>{{segment.segmentID == null ? segment.minSubtendedAngle + " - "+ segment.maxSubtendedAngle: ""}}</td>
                <td>
                  <input type="text" (change)="this.performanceService.report.performanceTable[i].notes = ($event.target.value)">
                </td>
              </tr>
            </tbody>
          </table>
          </div>
        </div>
      </div>
    </div>
    <div class="fields__block">
      <div class="fields__block__section">
        <div class="title">
          <h4>Performance Graphic Analysis</h4>
          <span></span>
        </div>
        <canvas id="coverageCanvas">


        </canvas>
      </div>

      <div class="fields__block__section">
        <div class="title">
          <h4>Run Planning</h4>
          <span></span>
        </div>
        <div class="table-fields">
          <div>
            <table>
              <thead>
                <th scope="col">Sequence Number</th>
                <th scope="col">Path Specification</th>
                <th scope="col">DME 1</th>
                <th scope="col">DME 2</th>
                <th scope="col">DME 3</th>
                <th scope="col">DME 4</th>
                <th scope="col">Notes</th>
              </thead>
              <tbody>
                <tr mdbTable *ngFor="let path of this.performanceService.paths; let pathIndex = index"
                [class.highlighted]="path.checked" (click)="this.checkPath(pathIndex)">
                  <td>{{pathIndex+1}}</td>
                  <td>
                    <select (change)="changePaths($event,pathIndex,'pathSpec')">
                      <option value="fullForward" selected>Full Forward</option>
                      <option value="fullBackward" >Full Backward</option>
                      <option value="partial" >Partial</option>
                      <option value="offCenterLine">Off-CenterLine</option>
                      <option value="altitideDeviation" >Path Specification</option>
                      <option value="other" >Other</option>
                    </select>
                  </td>
                  <td *ngFor="let i of [1,2,3,4]">
                    <select (change)="changePaths($event,pathIndex,this.getDMEField(i))">
                      <option value=" " selected> </option>
                      <option *ngFor="let navaid of this.pointsService.getRNAVNavaids()" value={{navaid.getProperties().navaidid}}>
                        {{navaid.getProperties().navaidid}}
                      </option>
                    </select>
                  </td>
                  <td>
                    <input type="text" (change)="this.performanceService.paths[pathIndex].runplanning.notes = ($event.target.value)">
                  </td>
                </tr>
              </tbody>
            </table>

          </div>
          <div class="btn">
            <button (click)="addPath()">Add Run</button>
            <button (click)="removePaths()">Remove Run</button>
            <button (click)="moveChecked('up')">Move Up</button>
            <button (click)="moveChecked('down')">Move Down</button>
          </div>
        </div>
      </div>
      <div class="fields__block__section">
        <div class="title">
          <h4> Waypoint Distance and Azimute Information</h4>
          <span></span>
        </div>
        <div class="table-fields">
          <div style="height: 240px; overflow-y: auto;">
            <table>
              <thead>
                <th scope="col">Waypoint ID</th>
                <th scope="col">Navaid ID</th>
                <th scope="col">Name</th>
                <th scope="col">Type</th>
                <th scope="col">Distance [{{this.configurationService.currentConfiguration == null ? ''
                                          : this.configurationService.currentConfiguration.display.horizontalUnits}}]</th>
                <th scope="col">Azimute [º]</th>
                <th scope="col">Shadowing</th>
              </thead>
              <tbody>
                <tr mdbTable *ngFor="let navaidInfo of this.wayPointInfoTable();let i= index">
                  <td>{{navaidInfo.waypointID}}</td>
                  <td>{{navaidInfo.navaidID}}</td>
                  <td>{{navaidInfo.name}}</td>
                  <td>{{navaidInfo.type}}</td>
                  <td>{{navaidInfo.distance}}</td>
                  <td>{{navaidInfo.azimute}}</td>
                  <td>{{navaidInfo.shadowing}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="fields__btn">
      <button class="blue" (click)="this.performanceService.generateReport()">Export Report</button>
    </div>
  </form>

</div>
